import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminConciergeHighlights = lazy(() => import("@/pages/admin/AdminConciergeHighlights"));

export const Route = createFileRoute("/admin/concierge-highlights")({
  component: AdminConciergeHighlights,
});
